import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { smartTagKeys } from './query-key-factory';

import type { QueryKey } from '@tanstack/react-query';
import type { RuleGroup } from 'src/app/components/lib/query-builder/use-query-builder';

const SAVE_SMART_TAG_ENDPOINT = 'api/smart-tags/save-smart-tag';

export const smartTagMutationQueryKey: QueryKey = ['save-smart-tag'];

type SaveSmartTagPayload = {
  Id: number | null;
  Name: string;
  RuleGroup: RuleGroup;
};
export const useSaveSmartTagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: smartTagMutationQueryKey,
    mutationFn: (payload: SaveSmartTagPayload) =>
      postData<SaveSmartTagPayload, void>({
        endpoint: SAVE_SMART_TAG_ENDPOINT,
        payload: { Name: payload.Name, RuleGroup: payload.RuleGroup, Id: payload.Id },
      }),
    onMutate: async (payload: SaveSmartTagPayload) => {
      if (payload.Id) {
        await queryClient.cancelQueries({ queryKey: smartTagKeys.one(payload.Id) });
        queryClient.setQueryData(smartTagKeys.one(payload.Id), (oldData: any) => ({
          ...oldData,
          tagDetails: payload.RuleGroup,
          name: payload.Name,
        }));
      }
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: smartTagKeys.many() });
      void queryClient.invalidateQueries({ queryKey: smartTagKeys.one(variables.Id) });
    },
    onError: async (error, variables) => {
      if (variables.Id) {
        await queryClient.invalidateQueries({ queryKey: smartTagKeys.one(variables.Id) });
      }
    },
  });
};
